module.exports = __webpack_public_path__ + "img/to_shrink.26c0971a.svg";